import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import classnames from 'classnames';
import {withRouter } from 'react-router-dom';

import ogImg from '../../assets/img/og.jpg';

import Image from '../../components/shared/backgroundImage';

import Footer from '../../components/shared/Footer';
import NavBar from '../../components/shared/NavBar';
import Description from '../../components/shared/imageDescription';
import Explore from '../../components/shared/explore.js';
import List from '../../components/shared/genericList';

class list extends Component { 
	constructor(props) {
		super(props);
		this.onTransitionEnd.bind(this);
		this.state = {
			index: null,
			data: null,
			loaded: false,
			transitionEnded: false,
		};
	}
	state = {
		transitionEnded: false,
	};
	onTransitionEnd = () => {
		this.setState({ transitionEnded: true }); 
	};
	componentDidUpdate(){
		let location = this.props.location.pathname;
		location = location.toLowerCase();
		let path;
		if (this.state.index == null){
			if (this.data){
				path = this.data.genericPageListingOfFiles;
				let i;
				for (i = 0; i < path.length; i++){
					if (location === '/' + path[i].route){
						this.setState({index: i});
						break;
					}
				}
			}
		}
	}

	render() {
		const heroClasses = classnames('hero', {
			animate: this.state.transitionEnded
		});
		if (!this.props.listPageQuery){
			return <div className="u-hidden"> Waiting</div>;
		}

		else if (this.props.listPageQuery && this.props.listPageQuery.loading) { 
			return <div className="u-hidden">Loading</div>; 
		}

		else if (this.props.listPageQuery && this.props.listPageQuery.error) {
			return <div className="u-hidden">Error </div>;
		}

		else {
			this.data = this.props.listPageQuery;
			if (!this.data) {
				window.location.href = '/404';
				return null;
			} 
			else{
				if (this.state.index != null){
					return(
						<div key="home" className={heroClasses}>   
							<Helmet>
								<meta property="og:image" content={ogImg}/>
								<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"/>
							</Helmet>
							<header id="site-header" className="container" role="banner">
								<a id="site-title" className="h1" href="/"> <img src={this.data.globalSites[0].cubsLogo.url} alt = "site-header"/></a>
								<Image introBackgrounds={this.data.genericPageListingOfFiles[this.state.index]}/>
								<NavBar NavBar={this.data.globalSites[0].mainNavigation}/>
								<div className="header-content">
									<div className="row2 padding-bottom">
										<Description description= {this.data.genericPageListingOfFiles[this.state.index]}/>
									</div>
								</div>
							</header>
							<main className="container">
								<List list = {this.props}/>
								<Explore explore={this.data.exploreComponents[0]}/>
							</main>
							<Footer footer={this.data.globalSites[0].mainNavigation}/>
						</div>
					);
				}
				else{
					return <div className="u-hidden">Loading</div>; 
				}
			}
		}
	}
}

export default withRouter(list);